import CustomersRoutes from './CustomersRoutes'

export default CustomersRoutes